import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSignedUrl } from "../api/utilsApi";
import { handleError } from "../slices/errorsSlice";


export const getSignedFileUrl = createAsyncThunk('utils/getSignedurl', async ({ query }, { getState, dispatch }) => {
  const { token } = getState().auth;

    try {
      const response = await getSignedUrl(token, query);
      if (response === undefined || response === null) throw new Error('Error al obtener URL');
      return response;
    } catch (err) {
      dispatch(handleError(err));
      throw err;
    }
});
